import { UpdatePurchaseLoadPaymentInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadUpdateAtom = createMutationAtomFactory(
  'trade.purchaseLoadUpdate',
  (params: {
    id: string;
    input: {
      receivedDate?: string | null;
      internalNotes?: string | null;
      externalNotes?: string | null;
      truckNumber?: string | null;
      trailerNumber?: string | null;
      payments?: UpdatePurchaseLoadPaymentInput[] | null;
    };
  }) => ({
    tradePurchaseLoadUpdate: {
      __args: {
        id: params.id,
        input: params.input,
      },
      id: true,
      receivedDate: true,
      internalNotes: true,
      externalNotes: true,
      truckNumber: true,
      trailerNumber: true,
      payments: {
        id: true,
        purchaseLoadId: true,
        paymentMethod: true,
        paymentTerm: true,
        amount: { amount: true, currencyCode: true },
        percentage: true,
        legalHold: true,
        financialAccountId: true,
        checkNumber: true,
        checkMemo: true,
      },
    },
  }),
  { showLoadingOverlay: false },
);
